import './DeskReservation.scss'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import DateUtil from '../../utils/DateUtil'

import table from './../../assets/icons/masa-gray.svg'
import building from './../../assets/icons/bina-gray.svg'
import calendar from './../../assets/icons/calendar-gray.svg'
import failedImage from './../../assets/images/failed-image.svg'
import warningImage from './../../assets/images/warning-image.svg'
import successImage from './../../assets/images/success-image.svg'
import rezervationTable from './../../assets/images/masan-hazir.svg'
import reservationTableEN from './../../assets/images/table-ready.png'
import location from './../../assets/icons/location-marker-gray.svg'
import emptyReservation from './../../assets/images/empty-reservation.png'
import emptyReservationEN from './../../assets/images/empty-reservation-en.png'
import loadingOfficeDesk from './../../assets/icons/loading-office-desk.png'
import warningIcon from './../../assets/icons/warning-icon.svg'
import defaultUserPicture from './../../assets/images/default-user-picture.svg'
import notificationSuccess from './../../assets/images/notification-success.svg'
import AsyncImage from '../ui/AsyncImage'
import logo from '../../assets/images/koc-logo.svg'

import noTableChoiceImg from './../../assets/images/no-table-choice.svg'

import { PlanTabs } from '../../types/PlanTabs'
import { IRemoteOfficeType, ISelectBox } from '../../types/MainType'
import { IDesk, IListTable } from '../../types/DeskType'
import { IFloorTemplate, Occupancy, OccupancyFilterRequest, ReservationMeta } from '../../types/FloorType'
import {
  EmployeeList,
  ICapacity,
  IReservationList,
  // IReservationListRequest,
  ISaveMultipleReservation,
  ISaveReservation,
} from '../../types/Reservation'
import FloorService from '../../service/FloorService'
import BlockService from '../../service/BlockService'
import ReservationService from '../../service/ReservationService'

import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Sidebar } from 'primereact/sidebar'
import { OverlayPanel } from 'primereact/overlaypanel'
import { ProgressSpinner } from 'primereact/progressspinner'
import { ProgressBar } from 'primereact/progressbar'
import EmployeeService from '../../service/EmployeeService'
import PlanService from '../../service/PlanService'

import SelectBox from '../ui/SelectBox/SelectBox'
import NotificationDialog from '../ui/NotificationDialog'
import useDidMountEffect from '../../utils/useDidMountEffect'
import ScrollContainer from 'react-indiana-drag-scroll'
import AuthUtil from '../../utils/AuthUtil'
import { IEmployeeSummary } from '../../types/Employee'
import { IFloorMessage } from '../../types/FloorMessageType'
import { useSelector } from 'react-redux'
import CalendarService from '../../service/CalendarService'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'

const DeskReservation = (props: {
  search: boolean
  loading: boolean
  selectedEmployee: EmployeeList | undefined
  deskList: IDesk[]
  floorTemplate: IFloorTemplate
  searchData: ReservationMeta
  onClick: (arg0: any) => any
  getPlanTabNum: () => any
  myReservation: boolean
  capacity: ICapacity[]
  modalText: IFloorMessage | undefined
}) => {
  const [selectedBlock, setSelectedBlock] = useState<ISelectBox>({
    id: props.searchData.selectedFloor?.blockId,
    name: props.searchData.selectedFloor?.blockName,
    fullness: 0,
  })
  const [selectedFloor, setSelectedFloor] = useState<ISelectBox>({
    id: props.searchData.selectedFloor?._id,
    name: props.searchData.selectedFloor?._floorName,
    fullness: 0,
  })
  const { t } = useTranslation()
  const [zoom, setZoom] = useState<number>(0)
  const [defaultZoom, setDefaultZoom] = useState<number>(1)

  const [blockList, setBlockList] = useState<ISelectBox[]>()
  const [floorList, setFloorList] = useState<ISelectBox[]>()

  const [reservation, setReservation] = useState<ISaveReservation>()
  const [multipleReservation, setMultipleReservation] = useState<ISaveMultipleReservation>()
  const [selectedDeskInfo, setSelectedDeskInfo] = useState<IListTable>()
  const [selectedReservation, setSelectedReservation] = useState<IReservationList | undefined>()

  const [visibleRight, setVisibleRight] = useState(false)
  const [displayBasic, setDisplayBasic] = useState(false)

  const [displayDeleteReservation, setDisplayDeleteReservation] = useState(false)
  const [deleteReservationSuccess, setDeleteReservationSuccess] = useState(false)
  const [deleteReservationFailed, setDeleteReservationFailed] = useState(false)
  const [floorMessage, setFloorMessage] = useState<IFloorMessage | undefined>()
  const [blockOccupancy, setBlockOccupancy] = useState<Occupancy | undefined>()
  const [floorOccupancy, setFloorOccupancy] = useState<Occupancy | undefined>()
  const [dayOffVisible, setDayOffVisible] = useState<boolean>(true)
  const [offDayMessage, setOffDayMessage] = useState<string[]>()
  const history = useHistory()
  const op = useRef<OverlayPanel>(null)
  const isMountedRef = useRef(true)

  const [warning, setWarning] = useState<string>('')
  const [reservationConfirmation, setReservationConfirmation] = useState<boolean>(false)
  const [multipleReservationConfirmation, setMultipleReservationConfirmation] = useState<boolean>(false)
  const [reservationFailed, setReservationFailed] = useState<boolean>(false)
  const [reservationFailedText, setReservationFailedText] = useState<string>()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [types, setTypes] = useState<IRemoteOfficeType[]>([])
  const [selectedType, setSelectedType] = useState<IRemoteOfficeType | null>(null)

  const [isMultipleReservation, setIsMultipleReservation] = useState<boolean>(false)
  const daysState = useSelector((state: any) => state.calendars)
  const [reservationDatesString, setReservationDatesString] = useState<string>('')
  const getAuthBlockList = (locationId: number, occupancyDate: Date, isMyFirm: boolean) => {
    BlockService.GetAuthBlockList(locationId, DateUtil.formatDateToString(occupancyDate), isMyFirm)
      .then((response) => {
        if (isMountedRef.current) {
          setBlockList(
            response.data?.map(function (block) {
              return {
                id: block.id,
                name: block.name,
                fullness: block.occupancy?.percentage,
              }
            })
          )
        }
      })
      .catch((e) => {
        if (isMountedRef.current) {
          console.log(e)
        }
      })
  }

  const formatDate = (date: Date | undefined) => {
    if (date === null || date === undefined) return ''
    let res = moment(date)
    return res.format('DD.MM.YYYY')
  }

  const getAuthFloorList = (blockIdId: number, occupancyDate: Date, isMyFirm: boolean) => {
    FloorService.GetAuthFloorList(blockIdId, DateUtil.formatDateToString(occupancyDate), isMyFirm)
      .then((response) => {
        if (isMountedRef.current) {
          setFloorList(
            response.data.map(function (floor) {
              return {
                id: floor.id,
                name: floor.name,
                fullness: floor.occupancy?.percentage,
              }
            })
          )
        }
      })
      .catch((e) => {
        if (isMountedRef.current) {
          console.log(e)
        }
      })
  }

  const getBlockOccupancy = (blockId: number, date: Date) => {
    let req: OccupancyFilterRequest = { id: blockId, occupancyDate: DateUtil.formatDateToString(date) }
    BlockService.GetBlockOccupancy(req)
      .then((response) => {
        if (isMountedRef.current) {
          setBlockOccupancy(response.data)
        }
      })
      .catch((e) => isMountedRef.current && console.log(e))
  }
  const getFloorOccupancy = (floorId: number, date: Date) => {
    let req: OccupancyFilterRequest = { id: floorId, occupancyDate: DateUtil.formatDateToString(date) }
    FloorService.GetFloorOccupancy(req)
      .then((response) => {
        if (isMountedRef.current) {
          setFloorOccupancy(response.data)
        }
      })
      .catch((e) => isMountedRef.current && console.log(e))
  }

  const [noTableChoice, setNoTableChoice] = useState<boolean>(false)

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useDidMountEffect(() => {
    if (props.searchData?.selectedFloor?.locationId) {
      getAuthBlockList(
        props.searchData.selectedFloor.locationId,
        props.searchData.startDate,
        props.searchData.planTab === PlanTabs.OFFICE
      )
    }
    if (selectedBlock?.id) {
      getAuthFloorList(selectedBlock.id, props.searchData.startDate, props.searchData.planTab === PlanTabs.OFFICE)
      getBlockOccupancy(selectedBlock.id, props.searchData.startDate)
    }
    if (selectedFloor?.id) {
      getFloorOccupancy(selectedFloor.id, props.searchData.startDate)
    }
    console.log('DeskReservation - deskList:', props.deskList)
    console.log('DeskReservation - floorTemplate:', props.floorTemplate)
  }, [props.deskList])

  useEffect(() => {
    if (!props.loading) {
      let floor = document.getElementById('floor')
      let floorTemp = document.getElementById('floor-temp')
      let floorDiv = document.getElementById('of-floor-plan')
      if (floorDiv && floorTemp) {
        let diffWidth = floorDiv?.offsetWidth - floorTemp?.offsetWidth
        let defaultZoom = Math.round(diffWidth / 100) * 0.2 + 1
        setDefaultZoom(defaultZoom)
        setZoom(0)
        if (floor) {
          floor.setAttribute('style', '')
          floor.style.transform = 'scale(' + defaultZoom + ')'
        }
      }
    }
  }, [props.loading])

  useEffect(() => {
    const timer = setTimeout(() => {
      let floor = document.getElementById('floor')
      let floorTemp = document.getElementById('floor-temp')
      let floorDiv = document.getElementById('of-floor-plan')
      let ofDeskReservation = document.getElementById('of-desk-reservation')
      if (floorTemp && floorDiv) {
        let diffWidth = floorDiv?.offsetWidth - floorTemp?.offsetWidth
        let defaultZoom = Math.round(diffWidth / 100) * 0.2 + 1
        setDefaultZoom(defaultZoom)
        setZoom(0)
        if (floor) {
          floor.setAttribute('style', '')
          floor.style.transform = 'scale(' + defaultZoom + ')'
        }
        if (floorDiv) {
          let divHeight = floorTemp?.offsetHeight * defaultZoom + 105
          floorDiv.setAttribute('style', '')
          floorDiv.style.height = ''
          floorDiv.style.width = ''
          floorDiv.style.height = divHeight - 100 + 'px'
          floorDiv.style.width = 'revert'
          floorDiv.style.display = 'grid'
          floorDiv.style.justifyContent = 'normal'
        }
        if (ofDeskReservation && floorTemp) {
          ofDeskReservation.setAttribute('style', '')
          let divHeight = floorTemp?.offsetHeight * defaultZoom + 105
          if (divHeight > 600) {
            ofDeskReservation.style.height = divHeight.toString() + 'px'
          }
        }
      }
    }, 500)
    return () => clearTimeout(timer)
  }, [props.loading])

  useDidMountEffect(() => {
    const timer = setTimeout(() => {
      let div = document.getElementById('floor')
      let plan = document.getElementById('of-floor-plan')
      let _zoom = zoom === 0 ? defaultZoom : defaultZoom + zoom
      if (div) {
        div.setAttribute('style', '')
        div.style.transform = 'scale(' + _zoom + ')'
      }
      if (plan) {
        plan.setAttribute('style', '')
        plan.style.height = ''
        plan.style.width = ''
        plan.style.height = 'calc(100% - 96px)'
        plan.style.width = 'revert'
      }
    }, 10)
    return () => clearTimeout(timer)
  }, [zoom])

  useDidMountEffect(() => {
    setSelectedBlock({
      id: selectedBlock?.id!,
      name: selectedBlock?.name!,
      fullness: blockOccupancy?.percentage!,
    })
    setSelectedFloor({
      id: selectedFloor?.id!,
      name: selectedFloor?.name!,
      fullness: floorOccupancy?.percentage!,
    })
  }, [blockOccupancy, floorOccupancy])
  // Takvimden Geliyorsa
  useDidMountEffect(() => {
    setSelectedBlock({
      id: props.searchData.selectedFloor?.blockId,
      name: props.searchData.selectedFloor?.blockName,
      fullness: blockOccupancy?.percentage!,
    })
    setSelectedFloor({
      id: props.searchData.selectedFloor?._id,
      name: props.searchData.selectedFloor?._floorName,
      fullness: floorOccupancy?.percentage!,
    })
  }, [props.search])

  useEffect(() => {
    if (props.selectedEmployee?.reservationList) {
      setSelectedReservation(undefined)
      setSelectedReservation(props.selectedEmployee?.reservationList[0])
      // @ts-ignore
      document.getElementById(props.selectedEmployee?.reservationList[0].tableId)?.click()
    }
  }, [props.selectedEmployee])
  useEffect(() => {
    ;(reservation?.tableId || reservation?.floorId) && saveReservation(reservation!)
  }, [reservation])

  useEffect(() => {
    ;(multipleReservation?.tableId || multipleReservation?.floorId) && saveMultipleReservation(multipleReservation!)
  }, [multipleReservation])

  useEffect(() => {
    if (visibleRight) {
      op.current?.hide()
    }
  }, [visibleRight])

  useEffect(() => {
    let isMounted = true
    
    const fetchOffDayList = () => {
      setOffDayMessage([])
      PlanService.GetMyPlanList(
        DateUtil.formatDateToString(props.searchData.startDate), 
        DateUtil.formatDateToString(props.searchData.endDate)
      ).then((res) => {
        if (isMounted) {
          let tempList: string[] = []
          res.data?.forEach((res) => {
            if (res.planType === 7) {
              i18next.language === 'en' ? tempList.push(res.descriptionDayOffEn) : tempList.push(res.description)
              setOffDayMessage(tempList)
            }
          })
        }
      })
    }
    
    fetchOffDayList()
    
    return () => {
      isMounted = false
    }
  }, [props.searchData, i18next.language])

  const selectFloor = (e: ISelectBox) => {
    setSelectedFloor(e)
    props.onClick(e)
  }
  const selectBlock = (e: ISelectBox) => {
    setSelectedBlock(e)
    setSelectedFloor(null!)
    getAuthFloorList(e?.id!, props.searchData.startDate, props.searchData.planTab === PlanTabs.OFFICE)
  }

  const saveReservation = (request: ISaveReservation) => {
    if (!getIsMultipleReservation()) {
      if (!props.searchData.selectedFloor.isReservable) {
        if (request.reservationDate.getTime() === request.reservationEndDate.getTime()) {
          ReservationService.saveReservation(request).then((response) => {
            if (response.data.isTransactionSuccess) {
              setDisplayBasic(true)
              props.onClick(selectedFloor)
            } else {
              setReservationFailed(true)
              setReservationFailedText(response.data.message)
            }
          })
        } else {
          ReservationService.saveMultiReservation(request).then((response) => {
            if (response.data.isTransactionSuccess) {
              setDisplayBasic(true)
              props.onClick(selectedFloor)
            } else {
              setReservationFailed(true)
              setReservationFailedText(response.data.message)
            }
          })
        }
      } else {
        ReservationService.saveFloorReservation(request).then((response) => {
          if (response.data.isTransactionSuccess) {
            setDisplayBasic(true)
            props.onClick(selectedFloor)
          } else {
            setReservationFailed(true)
            setReservationFailedText(response.data.message)
          }
        })
      }
    } else {
      setReservationFailed(true)
      setReservationFailedText('')
    }
  }

  const saveMultipleReservation = (request: ISaveMultipleReservation) => {
    if (getIsMultipleReservation()) {
      CalendarService.saveMultipleReservation(multipleReservation).then((response) => {
        if (response.data.isTransactionSuccess) {
          setDisplayBasic(true)
          props.onClick(selectedFloor)
        } else {
          setReservationFailed(true)
          setReservationFailedText(response.data.message)
        }
      })
    } else {
      setReservationFailed(true)
      setReservationFailedText('')
    }
  }
  const setReservations = () => {
    setWarning('')
    console.log('set rez')
    setReservationConfirmation(false)
    setReservation({
      floorId: selectedFloor.id,
      tableId: selectedDeskInfo?.id!,
      reservationDate: props.searchData.startDate,
      reservationEndDate: props.searchData.endDate,
    })
  }

  const setMultipleReservations = () => {
    setWarning('')
    setMultipleReservationConfirmation(false)
    let filteredDaysState = daysState.filter((value: any) => value.day.isChecked)

    let DateList: Date[] = []

    filteredDaysState.forEach((element: any) => {
      DateList.push(element.day.date)
    })
    let data: ISaveMultipleReservation = {
      floorId: selectedFloor.id,
      tableId: selectedDeskInfo?.id!,
      reservationDateList: DateList,
    }

    let planTabNum = props.getPlanTabNum()

    if (
      planTabNum === PlanTabs.COMMON &&
      (selectedDeskInfo?.id === null || selectedDeskInfo?.id === undefined || selectedDeskInfo.id === 0)
    ) {
      data.planType = 6
    } else if (
      planTabNum === PlanTabs.COMMON &&
      selectedDeskInfo?.id !== null &&
      selectedDeskInfo?.id !== undefined &&
      selectedDeskInfo.id > 0
    ) {
      data.planType = 4
    } else if (
      planTabNum === PlanTabs.OFFICE &&
      (selectedDeskInfo?.id === null || selectedDeskInfo?.id === undefined || selectedDeskInfo.id === 0)
    ) {
      data.planType = 5
    } else if (
      planTabNum === PlanTabs.OFFICE &&
      selectedDeskInfo?.id !== null &&
      selectedDeskInfo?.id !== undefined &&
      selectedDeskInfo.id > 0
    ) {
      data.planType = 2
    }

    setMultipleReservation(data)
  }

  const getIsMultipleReservation = () => {
    let filteredDaysState = daysState.filter((value: any) => value.day.isChecked)

    return filteredDaysState.length === 0 ? false : true
  }

  const selectDesk = (e: React.MouseEvent<HTMLDivElement>, desk: IListTable | any) => {
    if (props.searchData.startDate.getTime() === props.searchData.endDate.getTime()) {
      if (desk._status !== 'reserved-closed' && desk._status !== 'unavailable') {
        op.current?.toggle(e, e.target)
        setSelectedDeskInfo(desk)
      }
    } else {
      if (desk._status === 'available') {
        op.current?.toggle(e, e.target)
        setSelectedDeskInfo(desk)
      }
    }
  }

  const deleteReservation = (selectedDeskInfo: IListTable) => {
    if (selectedDeskInfo?._reservation?.length > 0) {
      let request = { id: selectedDeskInfo?._reservation[0].id }
      ReservationService.deleteReservation(request)
        .then((response) => {
          if (response.data.isTransactionSuccess) {
            setDeleteReservationSuccess(true)
            props.onClick(selectedFloor)
          } else {
            setDeleteReservationFailed(true)
          }
        })
        .catch((e) => {})
    }
  }
  const saveReservationRequest = () => {
    setVisibleRight(false)
    setIsLoading(true)
    myPlanList(props.searchData.startDate, props.searchData.endDate)
  }

  const renderLoading = () => {
    return (
      <div
        className={'loading'}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          minHeight: '100vh',
          zIndex: 1102,
        }}>
        <ProgressSpinner style={{ position: 'absolute', width: '120px', zIndex: 1102 }} />
        <img alt="Yükleniyor..." style={{ position: 'absolute', width: '60px', zIndex: 1102 }} src={logo} />
      </div>
    )
  }

  const myPlanList = (startDate: Date, endDate: Date) => {
    if (!getIsMultipleReservation()) {
      let hasAway = false
      let hasOffice = false
      let hasCommon = false

      PlanService.GetMyPlanList(DateUtil.formatDateToString(startDate), DateUtil.formatDateToString(endDate))
        .then((response) => {
          response.data.length > 0 &&
            response.data.map((res) => {
              if (res.planType === 1) {
                hasAway = true
              }
              if (res.planType === 2 || res.planType === 5) {
                hasOffice = true
              }
              if (res.planType === 4 || res.planType === 6) {
                hasCommon = true
              }
              return res
            })
        })
        .then(() => {
          let lastReservation =
            (hasAway ? (hasCommon || hasOffice ? ` ${t('plantype.remote')} /` : ` ${t('plantype.remote')}`) : '') +
            (hasOffice ? ' ' + t('plantype.from-office') : '') +
            (hasCommon ? (hasOffice ? `/ ${t('plantype.shared-office')} ` : `${t('plantype.shared-office')} `) : '')

          let newReservation =
            props.searchData.planTab === PlanTabs.OFFICE
              ? t('plantype.work-from-office2')
              : t('plantype.work-from-shared')
          let text = t('sidebar.full-remote-text', { reservation: lastReservation, newReservation: newReservation })

          if (!hasOffice && !hasCommon && !hasAway) {
            //setMultipleReservations()
            setReservations()
          } else {
            setWarning(text)
            setReservationConfirmation(true)
          }
          setIsLoading(false)
        })
    } else {
      let hasAway = false
      let hasOffice = false
      let hasCommon = false
      var dayList = daysState.filter((x: any) => x.day.isChecked)
      dayList.sort((day1: any, day2: any) => day1.day.date - day2.day.date)
      let reservationDateList: string[] = []
      dayList.forEach((value: any) => {
        reservationDateList.push(value.day.date.format('DD.MM.yyyy'))
      })
      let startDate = new Date(dayList[0]?.day?.date)
      let endDate = new Date(dayList[dayList.length - 1]?.day?.date)
      let hasReservation = false
      PlanService.GetMyPlanList(DateUtil.formatDateToString(startDate), DateUtil.formatDateToString(endDate))
        .then((response) => {
          let data = response.data.filter((item) => {
            return reservationDateList.some((value) => {
              return value === item.reservationDateStr
            })
          })

          data.sort((day1, day2) => new Date(day1.reservationDate).getTime() - new Date(day2.reservationDate).getTime())
          let dateString: string = ''
          data.length > 0 &&
            data.map((res, index) => {
              hasReservation = true

              if (res.planType === 1) {
                hasAway = true
              }
              if (res.planType === 2 || res.planType === 5) {
                hasOffice = true
              }
              if (res.planType === 4 || res.planType === 6) {
                hasCommon = true
              }
              dateString += res.reservationDateStr
              if (index < data.length - 1) {
                dateString += ', '
              }
              return res
            })

          setReservationDatesString(dateString)
        })
        .then(() => {
          let lastReservation =
            (hasAway ? (hasCommon || hasOffice ? `  ${t('plantype.remote')} /` : ` ${t('plantype.remote')}  `) : '') +
            (hasOffice ? ` ${t('plantype.from-office')} ` : '') +
            (hasCommon ? (hasOffice ? ` / ${t('plantype.shared-office')} ` : `${t('plantype.shared-office')} `) : '')
          let newReservation =
            (props.searchData.planTab === PlanTabs.OFFICE
              ? t('plantype.work-from-office2')
              : t('plantype.work-from-shared')) + ' '
          let text = t('sidebar.full-remote-text', { reservation: lastReservation, newReservation: newReservation })

          if (!hasReservation) {
            setMultipleReservations()
            //onClickMultipleRemotePlanEvent();
          } else {
            setWarning(text)
            setMultipleReservationConfirmation(true)
          }
          setIsLoading(false)
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }
  const goToCalendar = () => {
    history.push({
      pathname: '/calendar',
    })
  }

  const [employee, setEmployee] = useState<IEmployeeSummary>()

  useEffect(() => {
    let employeeSummary = AuthUtil.getEmployeeSummary()
    if (employeeSummary !== null) {
      setEmployee(employeeSummary)
    }
  }, [])

  const renderFloorPlanText = () => {
    return (
      <div className="text-center">
        <img className="of-plan-icon me-3" src={noTableChoiceImg} alt="" />
        <div className={'title mt-3'}>{t('res-tooltip.go-without-desk')}</div>
        <div className={'sub-title'}>{t('res-tooltip.start-work')}</div>
        <Button className="px-5 text-center d-table-cell mt-3 button" onClick={() => setVisibleRight(true)}>
          {t('buttons.complete-notification')}
        </Button>
      </div>
    )
  }

  const renderFloorPlanMandatory = () => {
    return (
      <div className="text-center">
        <img className="of-plan-icon me-3" src={noTableChoiceImg} alt="" />
        <div className={'title mt-3'}>{t('res-tooltip.go-without-desk')}</div>
        <div className={'sub-title'}>{t('res-tooltip.start-work')}</div>
        <Button className="px-5 text-center d-table-cell mt-3 button" onClick={() => setVisibleRight(true)}>
          {t('buttons.complete-notification')}
        </Button>
      </div>
    )
  }

  const renderFloorPlanWarningText = () => {
    return (
      <div className="text-center">
        <img className="of-plan-icon me-3" src={noTableChoiceImg} alt="" />
        <div className={'title mt-3'}>{t('res-tooltip.floor-warning-text')}</div>
        {/* <div className={'title mt-3'}>Bu katta sana tanımlı bir masa olduğundan bildirim yapamazsın.</div> */}
        <Button
          className="px-5 text-center d-table-cell mt-3 button"
          disabled={true}
          onClick={() => setVisibleRight(true)}>
          {t('buttons.complete-notification')}
        </Button>
      </div>
    )
  }
  const opProperties = useRef<OverlayPanel>(null)
  const showProperties = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!opProperties?.current?.state?.visible) {
      opProperties.current?.toggle(e, e.target)
    }
  }
  const hideProperties = (e: React.MouseEvent<HTMLDivElement>) => {
    opProperties?.current?.hide()
  }

  const getSelectedDayList = () => {
    let filteredDaysState = daysState.filter((value: any) => value.day.isChecked)

    //let dateListHtmlElements:any[] = [];
    let dateListString = ''
    if (filteredDaysState.length > 0) {
      filteredDaysState.forEach((element: any, index: any) => {
        dateListString += formatDate(element.day.date)
        if (index < filteredDaysState.length - 1) {
          dateListString += ', '
        }
      })
    }
    return dateListString
  }

  // @ts-ignore
  return (
    <div id={'of-desk-reservation'} className={'p-3 d-inline'}>
      {props.searchData.selectedFloor ? (
        !props.loading ? (
          <>
            <div className={'row'}>
              <div className={'col-12 col-xl-6 z-index-2'}>
                <div className={!props.searchData.selectedFloor.isReservable ? 'row pe-none' : 'row pe-none'}>
                  <div className={'col-6'}>
                    {blockList && (
                      <SelectBox
                        selected={selectedBlock}
                        placeholder={t('most-used-words.block')}
                        data={blockList!}
                        onClick={(e: ISelectBox) => selectBlock(e)}
                        oneDay={props.searchData.startDate.getTime() === props.searchData.endDate.getTime()}
                      />
                    )}
                    {selectedBlock && props.searchData.startDate.getTime() === props.searchData.endDate.getTime() && (
                      <div className={'mt-2 select-progress-bar'}>
                        <ProgressBar
                          color={
                            selectedBlock?.fullness < 34
                              ? '#CAD3FC'
                              : selectedBlock?.fullness < 67
                              ? '#9DAAEB'
                              : '#5868B8'
                          }
                          style={{ height: '8px' }}
                          value={selectedBlock?.fullness}
                          showValue={false}></ProgressBar>
                        <div className={'value'}>{selectedBlock?.fullness + '%'}</div>
                      </div>
                    )}
                  </div>
                  <div className={selectedBlock ? 'col-6' : 'col-6 of-disabled'}>
                    {blockList && (
                      <SelectBox
                        selected={selectedFloor}
                        placeholder={t('most-used-words.floor')}
                        data={floorList ? floorList! : []}
                        onClick={(e: ISelectBox) => selectFloor(e)}
                        oneDay={props.searchData.startDate.getTime() === props.searchData.endDate.getTime()}
                      />
                    )}
                    {selectedFloor && props.searchData.startDate.getTime() === props.searchData.endDate.getTime() && (
                      <div className={'mt-2 select-progress-bar'}>
                        <ProgressBar
                          color={
                            selectedFloor?.fullness < 34
                              ? '#CAD3FC'
                              : selectedFloor?.fullness < 67
                              ? '#9DAAEB'
                              : '#5868B8'
                          }
                          style={{ height: '8px' }}
                          value={selectedFloor?.fullness}
                          showValue={false}></ProgressBar>
                        <div className={'value'}>{selectedFloor?.fullness + '%'}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {!props.searchData.selectedFloor.isReservable ? (
                <div className={'col-10 col-xl-5 mb-auto mt-3 ps-5 ps-xl-3 z-index-2'}>
                  <div className="d-flex flex-row">
                    <div className="col">
                      <div className={'row'}>
                        <div className={'col-3 p-0'}>
                          <div className="d-flex flex-row align-items-center">
                            <div className={'of-legend-text available'}>{t('res-tooltip.available')}</div>
                          </div>
                        </div>
                        {props.searchData.startDate.getTime() === props.searchData.endDate.getTime() && (
                          <div className={'col-4 p-0'}>
                            <div className="d-flex flex-row align-items-center">
                              <div className={'of-legend-text my-reservation'}>{t('res-tooltip.my-reservation')}</div>
                            </div>
                          </div>
                        )}
                        {props.searchData.startDate.getTime() === props.searchData.endDate.getTime() && (
                          <div className={'col-5 p-0 align-items-center'}>
                            <div className="d-flex flex-row align-items-center">
                              <div className={'of-legend-text reserved'}>{t('res-tooltip.reserved')}</div>
                            </div>
                          </div>
                        )}
                        {props.searchData.startDate.getTime() !== props.searchData.endDate.getTime() && (
                          <div className={'col-9 p-0 align-items-center'}>
                            <div className="d-flex flex-row">
                              <div className={'of-legend-text reserved'}>{t('res-tooltip.not-available-for-res')}</div>
                              <div
                                className="ms-4"
                                onMouseOver={(e) => showProperties(e)}
                                onMouseLeave={(e) => hideProperties(e)}>
                                <i className="pi pi-info-circle info-icon"></i>
                              </div>
                            </div>
                          </div>
                        )}

                        {props.searchData.startDate.getTime() !== props.searchData.endDate.getTime() && (
                          <div className={'col-12 p-0'}>
                            <div className="d-flex flex-row align-items-center">
                              <div className={'of-legend-text reserved-closed'}>{t('res-tooltip.no-reservation')}</div>

                              <OverlayPanel ref={opProperties} className="info-popup">
                                <div className="p-1">
                                  <div className="info-popup-title" style={{ color: '#45bfe5' }}>
                                    <i className="pi pi-info-circle info-icon"></i>{' '}
                                    {t('overlaypanel-texts.info-header')}
                                  </div>
                                  <div>
                                    {t('res-tooltip.closed-to-res')}:{' '}
                                    {props.searchData.selectedFloor.occupancy?.unavailableCount}
                                  </div>
                                </div>
                              </OverlayPanel>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className={'row'}>
                        <div className={'col-3 p-0'}>
                          {props.searchData.startDate.getTime() === props.searchData.endDate.getTime() && (
                            <div className="d-flex flex-row align-items-center">
                              <div className={'of-legend-text crew'}>{t('res-tooltip.my-squad')}</div>
                            </div>
                          )}
                        </div>
                        <div className={'col-4 p-0'}>
                          {props.searchData.startDate.getTime() === props.searchData.endDate.getTime() && (
                            <div className="d-flex flex-row align-items-center">
                              <div className={'of-legend-text team'}>{t('res-tooltip.my-team')}</div>
                            </div>
                          )}
                        </div>
                        <div className={'col-5 p-0 align-items-center'}>
                          {props.searchData.startDate.getTime() === props.searchData.endDate.getTime() && (
                            <div className="d-flex flex-row align-items-center">
                              <div className={'of-legend-text reserved-closed me-2'}>
                                {t('res-tooltip.no-reservation')}
                              </div>
                              <div onMouseOver={(e) => showProperties(e)} onMouseLeave={(e) => hideProperties(e)}>
                                <i className="pi pi-info-circle info-icon"></i>
                              </div>
                              <OverlayPanel ref={opProperties} className="info-popup">
                                <div className="p-1">
                                  <div className="fw-bold" style={{ color: '#45bfe5' }}>
                                    <i className="pi pi-info-circle info-icon"></i>{' '}
                                    {t('overlaypanel-texts.info-header')}
                                  </div>
                                  <div>
                                    {t('res-tooltip.closed-to-res')}:{' '}
                                    {props.searchData.selectedFloor.occupancy?.unavailableCount}
                                  </div>
                                </div>
                              </OverlayPanel>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-10 col-xl-5 mb-auto mt-3 ps-5 ps-xl-3 z-index-2 text-end remaining-capacity-text">
                  {t('res-tooltip.available-quota')} ( {props?.capacity && props?.capacity[0]?.remainingCapacity} )
                </div>
              )}
              {!props.searchData.selectedFloor.isReservable && (
                <div className={'col-2 col-xl-1'}>
                  <div className="z-index-2">
                    <div className={'zoom-button'}>
                      <Button
                        disabled={zoom === 1}
                        icon="pi pi-plus"
                        className="p-button-secondary p-button-text z-index-2 w-100"
                        tooltip={t('res-tooltip.zoom-in')}
                        tooltipOptions={{
                          position: 'bottom',
                          mouseTrack: true,
                          mouseTrackTop: 15,
                        }}
                        onClick={() =>
                          setZoom((prevZoom) => (prevZoom < 1 ? parseFloat((prevZoom + 0.2).toFixed(10)) : 1))
                        }
                      />
                      <div className={'zoom-line'} />

                      <Button
                        disabled={zoom === 0}
                        icon="pi pi-minus"
                        className="p-button-secondary p-button-text z-index-2 w-100"
                        tooltip={t('res-tooltip.zoom-out')}
                        tooltipOptions={{
                          position: 'bottom',
                          mouseTrack: true,
                          mouseTrackTop: 15,
                        }}
                        onClick={() =>
                          setZoom((prevZoom) => (prevZoom > 0.2 ? parseFloat((prevZoom - 0.2).toFixed(10)) : 0))
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {!props.searchData.selectedFloor.isReservable ? (
              <div id={'of-floor-plan'} className={'of-floor-plan'}>
                <ScrollContainer className="scroll-container" style={{ width: zoom === 1 ? '100%' : '100%' }}>
                  <div id="floor" className={'floor position-relative'}>
                    <img
                      id="floor-temp"
                      className={'of-floor-map'}
                      src={props.floorTemplate?.drawing ? `data:image/png;base64,${props.floorTemplate.drawing}` : ''}
                      alt="Floor Plan"
                    />
                    {props.deskList &&
                      props.deskList.map((desks, index) => (
                        <div
                          key={desks.id}
                          className={'of-desks'}
                          style={{
                            top: desks.topVal,
                            left: desks.leftVal,
                            width: desks.widthVal,
                            height: desks.heightVal,
                            transform: `rotate(${desks.rotateVal}deg)`,
                          }}>
                          <div
                            className={
                              desks.heightVal > desks.widthVal
                                ? 'of-table-container flex-column '
                                : 'of-table-container flex-row'
                            }>
                            {desks.listTable?.map((desk, index) => (
                              <div
                                id={desk.id?.toString()}
                                onClick={(e) => {
                                  selectDesk(e, desk)
                                }}
                                aria-haspopup
                                aria-controls="overlay_panel"
                                key={index}
                                className={'of-desk-container'}>
                                <div
                                  className={
                                    selectedDeskInfo?.id === desk.id
                                      ? 'of-desk selected-desk ' + desk._status
                                      : 'of-desk ' + desk._status
                                  }></div>
                                <div
                                  style={{
                                    left:
                                      desk.chairPosition === 2
                                        ? desks.widthVal
                                        : desk.chairPosition === 4
                                        ? -8
                                        : desks.widthVal / (desks.listTable.length * 2) +
                                          index * (desks.widthVal / desks.listTable.length) -
                                          5,
                                    top:
                                      desk.chairPosition === 1
                                        ? -8
                                        : desk.chairPosition === 3
                                        ? desks.heightVal
                                        : desk.chairPosition === 2
                                        ? desks.heightVal / (desks.listTable.length * 2) +
                                          (desks.heightVal / desks.listTable.length) * index -
                                          5
                                        : desks.heightVal / (desks.listTable.length * 2) +
                                          (desks.heightVal / desks.listTable.length) * index -
                                          5,
                                  }}
                                  className={'of-chair ' + desk._status}></div>
                              </div>
                            ))}
                            <OverlayPanel ref={op} id={'overlay_panel'} className="overlaypanel">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <span className="title">{t('calendar.table-no')}</span> :{' '}
                                  <span className={'title table-num ' + selectedDeskInfo?._status}>
                                    {selectedDeskInfo?.tableNum}
                                  </span>
                                </div>
                                <div>
                                  <i
                                    className="close-icon arrow pi pi-times of-times-btn"
                                    onClick={(e) => op?.current?.hide()}
                                  />
                                </div>
                              </div>
                              <div>
                                {selectedDeskInfo?._reservation?.length === 0 && (
                                  <>
                                    <div className="d-flex align-items-center mt-4">
                                      <img className={'me-2'} src={defaultUserPicture} alt="" />
                                      <div>{t('res-tooltip.available-for-res')}</div>
                                    </div>
                                    <div className={'mt-3'}>
                                      <Button
                                        onClick={() => setVisibleRight(true)}
                                        className="w-100 button"
                                        label={t('buttons.book-table')}
                                      />
                                    </div>
                                  </>
                                )}
                                {selectedDeskInfo?._reservation?.length! > 0 ? (
                                  <>
                                    <div className="d-flex align-items-center mt-4">
                                      <div>
                                        <AsyncImage
                                          className={'me-2 picture'}
                                          src={EmployeeService.getEmployeePhotoUrlById(
                                            selectedDeskInfo?._reservation[0].employeeId!
                                          )}
                                          alt=""
                                        />
                                      </div>
                                      <div>
                                        <div className={'name'}>
                                          {selectedDeskInfo?._reservation[0].employeeFullName}
                                        </div>
                                        <div className={'position'}>
                                          {selectedDeskInfo?._reservation[0].employeePositionName}
                                        </div>
                                      </div>
                                    </div>
                                    {selectedDeskInfo?._status === 'my-reservation' ? (
                                      <div className={'mt-3'}>
                                        <Button
                                          onClick={() => setDisplayDeleteReservation(true)}
                                          className="w-100 button"
                                          label={t('buttons.cancel2')}
                                        />
                                      </div>
                                    ) : (
                                      <div className={'mt-3'}>
                                        <Button className="w-100 button" label={t('buttons.book-table')} disabled />
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </OverlayPanel>
                          </div>
                        </div>
                      ))}
                  </div>
                </ScrollContainer>
              </div>
            ) : (
              <div className={'align-items-center of-floor-plan noTableChoice'}>
                {props.searchData.selectedFloor.hasDedicatedTable
                  ? employee?.dedicatedReservationMandatory
                    ? renderFloorPlanMandatory()
                    : renderFloorPlanWarningText()
                  : renderFloorPlanText()}
              </div>
            )}
            <Sidebar
              style={{ width: '500px' }}
              className={'of-reservation-sidebar'}
              visible={visibleRight}
              position="right"
              onHide={() => setVisibleRight(false)}>
              <div className="text-center">
                <div className={'title'}>
                  {props.searchData.planTab === PlanTabs.OFFICE
                    ? t('reservation-tab.office-not')
                    : t('reservation-tab.shared-not')}
                </div>
                <div className={'content mt-2'}>{t('reservation-tab.confirm-text')}</div>
                <div className={'mt-3 mb-1'}>
                  <img
                    width={'159px'}
                    height="166px"
                    src={i18next.language === 'en' ? reservationTableEN : rezervationTable}
                    alt="desktop-icon"
                  />
                </div>
              </div>
              <div className={'info-title'}>
                {props.searchData.planTab === PlanTabs.OFFICE
                  ? t('reservation-tab.office-info')
                  : t('reservation-tab.shared-info')}
              </div>

              <div className={'ps-3'}>
                <div className="d-flex justify-content-start mt-4">
                  <img className="of-plan-icon me-3" src={calendar} alt="" />
                  <div>
                    <span className={'info-sub-title'}>{t('input-texts.date')}</span> :{' '}
                    <span className={'info-sub-content'}>
                      {getIsMultipleReservation()
                        ? getSelectedDayList()
                        : DateUtil.dateFormat(props.searchData.startDate) +
                          ' / ' +
                          DateUtil.dateFormat(props.searchData.endDate)}
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-start mt-4">
                  <img className="of-plan-icon me-3" src={location} alt="" />

                  <div>
                    <div>
                      <span className={'info-sub-title'}>{t('most-used-words.location')}</span> :{' '}
                      <span className={'info-sub-content'}>{props.searchData.selectedFloor.locationFirmName}</span>
                    </div>
                    <div>
                      <span className={'info-sub-content'}>
                        {props.searchData.selectedFloor.locationName} {props.searchData.selectedFloor.cityName} /{' '}
                        {props.searchData.selectedFloor.countryName}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-start mt-4">
                  <img className="of-plan-icon me-3" src={building} alt="" />
                  <div>
                    <div>
                      <span className={'info-sub-title'}>{t('most-used-words.block')}</span> :{' '}
                      <span className={'info-sub-content'}>{props.searchData.selectedFloor.blockName}</span>
                    </div>
                    <div>
                      <span className={'info-sub-title'}>{t('most-used-words.floor')}</span> :{' '}
                      <span className={'info-sub-content'}>{props.searchData.selectedFloor._floorName}</span>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-start mt-4">
                  <img className="of-plan-icon me-3" src={table} alt="" />
                  <div>
                    <span className={'info-sub-title'}>{t('calendar.table-no')}</span> :{' '}
                    <span className={'info-sub-content'}>
                      {!props.searchData.selectedFloor.isReservable
                        ? selectedDeskInfo?.tableNum
                        : t('sidebar.table-without-choice')}
                    </span>
                  </div>
                </div>
                {props.modalText?.trMessage && (
                  <div className="d-flex justify-content-start mt-4">
                    <img className="of-plan-icon me-3" src={warningIcon} alt="" />
                    <div>
                      <span className={'info-sub-content'}>
                        {i18next.language === 'en' ? props.modalText.enMessage : props.modalText?.trMessage}
                      </span>
                    </div>
                  </div>
                )}
                {offDayMessage?.map((item) => {
                  return (
                    <div className="d-flex justify-content-start mt-4">
                      <img className="of-plan-icon me-3" src={warningIcon} alt="" />
                      <span className={'info-sub-content'}>{item}</span>
                    </div>
                  )
                })}
              </div>
              <div className={'bottom-0 end-0 start-0 of-rez-button'}>
                <Button
                  onClick={() => {
                    saveReservationRequest()
                  }}
                  className="w-100 text-center d-table-cell mb-3 mt-1">
                  {t('buttons.confirm')}
                </Button>
              </div>
            </Sidebar>
            <Dialog
              contentClassName={'reservation-dialog'}
              visible={displayBasic}
              style={{ width: '400px' }}
              onHide={() => setDisplayBasic(false)}>
              <div className="text-center">
                <img className="mt-5" src={notificationSuccess} alt="icon" />
                <div className="mt-3 title">{t('success-text.reservation-completed')}</div>
                {props.searchData.planTab === PlanTabs.OFFICE ? (
                  <div className="mt-3"> {t('success-text.office-success')}</div>
                ) : (
                  <div className="mt-3"> {t('success-text.shared-success')}</div>
                )}
                <div className={'row'}>
                  <Button
                    onClick={() => history.push('/calendar')}
                    className={'w-100 text-center d-table-cell my-4 button'}>
                    {t('buttons.go-to-calendar')}
                  </Button>
                </div>
              </div>
            </Dialog>
            <NotificationDialog
              display={reservationFailed}
              imgSrc={failedImage}
              goHomeButton={true}
              title={t('failed.failed-reservation')}
              content={reservationFailedText}
              firstButtonLabel={t('buttons.go-to-calendar')}
              onHide={() => setReservationFailed(false)}
              onSubmit={() => {
                history.push('/calendar')
              }}
              selectedType={null}
              setSelectedType={undefined}
              types={[]}></NotificationDialog>

            <NotificationDialog
              display={deleteReservationSuccess}
              imgSrc={successImage}
              types={[]}
              setSelectedType={() => {}}
              selectedType={null}
              goHomeButton={true}
              title={t('overlaypanel-texts.cancel-process')}
              content={
                props.searchData.planTab === PlanTabs.OFFICE
                  ? t('deletion-texts.firm-office-cancel')
                  : t('deletion-texts.shared-office-deletion')
              }
              firstButtonLabel={t('buttons.go-to-calendar')}
              onHide={() => setDeleteReservationSuccess(false)}
              onSubmit={() => {
                history.push('/calendar')
              }}></NotificationDialog>

            <NotificationDialog
              display={deleteReservationFailed}
              imgSrc={failedImage}
              types={[]}
              setSelectedType={() => {}}
              selectedType={null}
              goHomeButton={true}
              title={t('overlaypanel-texts.cancel-process')}
              content={
                props.searchData.planTab === PlanTabs.OFFICE
                  ? t('deletion-texts.cancel-failed-firm')
                  : t('deletion-texts.cancel-failed-shared')
              }
              firstButtonLabel={t('buttons.go-to-calendar')}
              onHide={() => setDeleteReservationFailed(false)}
              onSubmit={() => {
                history.push('/calendar')
              }}></NotificationDialog>

            <NotificationDialog
              display={displayDeleteReservation}
              imgSrc={warningImage}
              types={[]}
              setSelectedType={() => {}}
              selectedType={null}
              extraButton={true}
              title={t('overlaypanel-texts.cancel-process')}
              content={
                props.searchData.planTab === PlanTabs.OFFICE
                  ? t('overlaypanel-texts.cancel-from-office')
                  : t('overlaypanel-texts.cancel-from-shared')
              }
              firstButtonLabel={t('buttons.yes')}
              secondButtonLabel={t('buttons.no')}
              textDate={
                props.searchData.startDate.getTime() === props.searchData.endDate.getTime()
                  ? DateUtil.dateFormat(props.searchData.startDate)
                  : DateUtil.dateFormat(props.searchData.startDate) +
                    '-' +
                    DateUtil.dateFormat(props.searchData.endDate)
              }
              onHide={() => setDisplayDeleteReservation(false)}
              onSubmit={() => {
                console.log('deleteRes submit')
                deleteReservation(selectedDeskInfo!)
                setDisplayDeleteReservation(false)
              }}></NotificationDialog>

            <NotificationDialog
              display={reservationConfirmation}
              imgSrc={failedImage}
              goHomeButton={true}
              types={[]}
              setSelectedType={() => {}}
              selectedType={null}
              title={t('overlaypanel-texts.confirmation')}
              content={warning}
              firstButtonLabel={t('buttons.confirm')}
              onHide={() => {
                setReservationConfirmation(false)
                setWarning('')
              }}
              onSubmit={() => setReservations()}></NotificationDialog>

            {/*  Multiple Reservation's Notification Dialogs*/}
            <NotificationDialog
              display={multipleReservationConfirmation}
              imgSrc={failedImage}
              goHomeButton={true}
              title={t('overlaypanel-texts.confirmation')}
              types={[]}
              setSelectedType={() => {}}
              selectedType={null}
              content={warning}
              textDate={reservationDatesString}
              firstButtonLabel={t('buttons.confirm')}
              onHide={() => {
                setMultipleReservationConfirmation(false)
                setWarning('')
              }}
              onSubmit={() => setMultipleReservations()}></NotificationDialog>
          </>
        ) : (
          <div className={'h-100'}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
              }}>
              <ProgressSpinner style={{ width: '120px' }} />
              <img style={{ position: 'absolute', width: '40px' }} src={loadingOfficeDesk} alt="" />
            </div>
          </div>
        )
      ) : (
        <div className="p-5 justify-content-center d-flex align-items-center">
          <img
            width={'645px'}
            height="443px"
            src={i18next.language === 'en' ? emptyReservationEN : emptyReservation}
            alt=""></img>
        </div>
      )}
      {isLoading ? renderLoading() : null}
    </div>
  )
}
export default DeskReservation
